import i18n from "@/config/i18n";
/**
 * 充电营收趋势图 数据
 * @param data
 * @returns
 */
export const getBigRevenueDataReturn = (data) => {
    const totalName = i18n.t("homeData.revenueTotalTitle") + "";
    const time = [];
    // const total: number[] = [];
    const df = [];
    const server = [];
    const delayAmount = [];
    let totalAmount = 0; // 总费用
    let totalElecAmount = 0; // 总电费
    let totalSeviceAmount = 0; // 总服务费
    let totalDelayAmount = 0; // 总服务费
    data.map((item) => {
        time.push(item.name);
        // total.push(item.totalAmount);
        df.push(item.totalElecAmount);
        server.push(item.totalSeviceAmount);
        delayAmount.push(item.totalDelayAmount);
        totalAmount += item.totalAmount;
        totalElecAmount += item.totalElecAmount;
        totalSeviceAmount += item.totalSeviceAmount;
        totalDelayAmount += item.totalDelayAmount;
    });
    const chargeLineData = {
        time: time,
        barWidth: 3,
        data: [
            // { name: totalName, data: total },
            {
                name: i18n.t("homeData.echartRevenueServer"),
                data: server,
                color: [
                    { offset: 0, color: "rgba(0,255,255,1)" },
                    { offset: 1, color: "rgba(0,255,255,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartRevenueDf"),
                data: df,
                color: [
                    { offset: 0, color: "rgba(0,199,255,1)" },
                    { offset: 1, color: "rgba(0,199,255,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartRevenueDelayAmount"),
                data: delayAmount,
                color: [
                    { offset: 0, color: "rgba(100,66,255,1)" },
                    { offset: 1, color: "rgba(100,66,255,0)" },
                ],
            },
        ],
        // legendLineFeedIndex: i18n.locale == "en-US" ? 1 : 3, // 名称在第几个换行
        color: ["#00FFFF", "#00C7FF", "#6442FF"],
    };
    const chargePieData = {
        data: [
            {
                value: totalSeviceAmount.toFixed(2),
                name: i18n.t("homeData.echartRevenueServer"),
            },
            {
                value: totalElecAmount.toFixed(2),
                name: i18n.t("homeData.echartRevenueDf"),
            },
            {
                value: totalDelayAmount.toFixed(2),
                name: i18n.t("homeData.echartRevenueDelayAmount"),
            },
        ],
        color: ["#00FFFF", "#00C7FF", "#6442FF"],
        totalAmount: totalAmount.toFixed(2),
        totalName: totalName,
        titlePie: i18n.t("homeData.revenuePieTitle") + "",
    };
    return {
        chargeLineData: chargeLineData,
        chargePieData: chargePieData,
    };
};
/**
 * 充电电量趋势图
 * @param data
 * @returns
 */
export const getBigChargingDataReturn = (data) => {
    const totalName = i18n.t("homeData.dlTotalTitle") + "";
    const time = [];
    // const total: number[] = [];
    const sharpPower = []; // 尖
    const peakPower = []; // 峰
    const flatPower = []; // 平
    const valleyPower = []; // 谷
    let totalPower = 0; // 总费用
    let sharpPowerTotal = 0; // 尖
    let peakPowerTotal = 0; // 峰
    let flatPowerTotal = 0; // 平
    let valleyPowerTotal = 0; // 谷
    data.map((item) => {
        time.push(item.name);
        // total.push(item.totalPower);
        peakPower.push(item.peakPower);
        flatPower.push(item.flatPower);
        sharpPower.push(item.sharpPower);
        valleyPower.push(item.valleyPower);
        totalPower += item.totalPower;
        peakPowerTotal += item.peakPower;
        flatPowerTotal += item.flatPower;
        sharpPowerTotal += item.sharpPower;
        valleyPowerTotal += item.valleyPower;
    });
    const chargeLineData = {
        time: time,
        data: [
            // { name: totalName, data: total },
            {
                name: i18n.t("homeData.echartDlSharp"),
                data: sharpPower,
                color: [
                    { offset: 0, color: "rgba(53,188,73,1)" },
                    { offset: 1, color: "rgba(53,188,73,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartDlPeak"),
                data: peakPower,
                color: [
                    { offset: 0, color: "rgba(231,214,25,1)" },
                    { offset: 1, color: "rgba(231,214,25,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartDlFlat"),
                data: flatPower,
                color: [
                    { offset: 0, color: "rgba(29,69,237,1)" },
                    { offset: 1, color: "rgba(29,69,237,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartDlValley"),
                data: valleyPower,
                color: [
                    { offset: 0, color: "rgba(86,169,253,1)" },
                    { offset: 1, color: "rgba(86,169,253,0)" },
                ],
            },
        ],
        totalName: totalName,
        legendLineFeedIndex: i18n.locale == "en-US" ? 2 : 4,
        color: ["#35BC49", "#E7D619", "#1D45ED", "#56A9FD"],
    };
    const chargePieData = {
        data: [
            {
                value: sharpPowerTotal.toFixed(2),
                name: i18n.t("homeData.echartDlSharp"),
            },
            {
                value: peakPowerTotal.toFixed(2),
                name: i18n.t("homeData.echartDlPeak"),
            },
            {
                value: flatPowerTotal.toFixed(2),
                name: i18n.t("homeData.echartDlFlat"),
            },
            {
                value: valleyPowerTotal.toFixed(2),
                name: i18n.t("homeData.echartDlValley"),
            },
        ],
        color: ["#35BC49", "#E7D619", "#1D45ED", "#56A9FD"],
        totalAmount: totalPower.toFixed(2),
        totalName: totalName,
        titlePie: i18n.t("homeData.dlPieTitle") + "",
    };
    return {
        chargeLineData: chargeLineData,
        chargePieData: chargePieData,
    };
};
/**
 * 充电订单趋势图
 * @param data
 * @returns
 */
export const getBigChargingOrderDataReturn = (data) => {
    const totalName = i18n.t("homeData.orderTotalTitle") + "";
    const time = [];
    // const total: number[] = []; // 总订单
    const userCount = []; // 普通用户订单
    const entCount = []; // 企业用户订单
    const netCount = []; // 渠道用户订单
    let totalOrder = 0;
    let userCountTotal = 0;
    let entCountTotal = 0;
    let netCountTotal = 0;
    data.map((item) => {
        time.push(item.name);
        // total.push(item.orderCount);
        userCount.push(item.userCount);
        entCount.push(item.entCount);
        netCount.push(item.netCount);
        totalOrder += item.orderCount;
        userCountTotal += item.userCount;
        entCountTotal += item.entCount;
        netCountTotal += item.netCount;
    });
    const chargeLineData = {
        time: time,
        data: [
            {
                name: i18n.t("homeData.echartUserOrder"),
                data: userCount,
                color: [
                    { offset: 0, color: "rgba(90,216,166,1)" },
                    { offset: 1, color: "rgba(90,216,166,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartUserOrderEnt"),
                data: entCount,
                color: [
                    { offset: 0, color: "rgba(51,153,255,1)" },
                    { offset: 1, color: "rgba(51,153,255,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartUserOrderNet"),
                data: netCount,
                color: [
                    { offset: 0, color: "rgba(246,189,22,1)" },
                    { offset: 1, color: "rgba(246,189,22,0)" },
                ],
            },
        ],
        legendLineFeedIndex: i18n.locale == "en-US" ? 1 : 2,
        totalName: totalName,
        color: ["#5AD8A6", "#3399FF", "#F6BD16"],
    };
    const chargePieData = {
        data: [
            {
                value: userCountTotal.toFixed(2),
                name: i18n.t("homeData.echartUserOrder"),
            },
            {
                value: entCountTotal.toFixed(2),
                name: i18n.t("homeData.echartUserOrderEnt"),
            },
            {
                value: netCountTotal.toFixed(2),
                name: i18n.t("homeData.echartUserOrderNet"),
            },
        ],
        color: ["#5AD8A6", "#3399FF", "#F6BD16"],
        totalAmount: totalOrder.toFixed(2),
        totalName: totalName,
        titlePie: i18n.t("homeData.orderPieTitle") + "",
    };
    return {
        chargeLineData: chargeLineData,
        chargePieData: chargePieData,
    };
};
/**
 * 充电用户数量趋势图
 * @param data
 * @returns
 */
export const getBigUserDataReturn = (data) => {
    const totalName = i18n.t("homeData.userLineTitle") + "";
    const time = [];
    const total = [];
    const active = [];
    data.map((item) => {
        time.push(item.name);
        total.push(item.value);
        active.push(item.activeUserNum);
    });
    const chargeLineData = {
        time: time,
        data: [
            {
                name: i18n.t("homeData.chargeUser"),
                data: total,
                color: [
                    { offset: 0, color: "rgba(246,189,22,0.3)" },
                    { offset: 1, color: "rgba(246,189,22,0)" },
                ],
            },
            {
                name: i18n.t("homeData.activeUserNum"),
                data: active,
                color: [
                    { offset: 0, color: "rgba(255,0,0,0.3)" },
                    { offset: 1, color: "rgba(255,0,0,0)" },
                ],
            },
        ],
        color: ["#F6BD16", "#FF0000"],
        totalName: totalName,
    };
    const chargePieData = {};
    return {
        chargeLineData: chargeLineData,
        chargePieData: chargePieData,
    };
};
/**
 * 使用率与利用率趋势图
 * @param data
 * @returns
 */
export const getEfficiencyDataReturn = (data) => {
    const totalName = "";
    const time = [];
    const useRatio = [];
    const usageRate = [];
    data.map((item) => {
        time.push(item.name);
        if (item.useRatio >= 0 && item.useRatio != null) {
            useRatio.push(item.useRatio.toFixed(2));
        }
        else {
            useRatio.push("");
        }
        if (item.usageRate >= 0 && item.usageRate != null) {
            usageRate.push(item.usageRate.toFixed(2));
        }
        else {
            usageRate.push("");
        }
    });
    const chargeLineData = {
        time: time,
        data: [
            {
                name: i18n.t("homeData.echartUseRatio"),
                data: useRatio,
                color: [
                    { offset: 0, color: "rgba(127,255,0,0.3)" },
                    { offset: 1, color: "rgba(127,255,0,0)" },
                ],
            },
            {
                name: i18n.t("homeData.echartUsageRate"),
                data: usageRate,
                color: [
                    { offset: 0, color: "rgba(0,255,255,0.3)" },
                    { offset: 1, color: "rgba(0,255,255,0)" },
                ],
            },
        ],
        color: ["#5FFF40", "#00FFFF"],
        totalName: totalName,
    };
    const chargePieData = {};
    return {
        chargeLineData: chargeLineData,
        chargePieData: chargePieData,
    };
};
